import { memo, useCallback, useContext, useState } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { SensitiveActionModal } from 'src/components/shared/SensitiveActionModal'
import { CircleTickMajor } from '@shopify/polaris-icons'
import { ContractorDetailsModalContext } from '../ContractorDetailsModal.context'

interface Props {
  onUnreject(): void
}

const UnrejectContractorComponent = ({ onUnreject }: Props) => {
  const { statusIsUpdating } = useContext(ContractorDetailsModalContext)

  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const handleOpenConfirm = useCallback(() => {
    setIsConfirmOpen(true)
  }, [])

  const handleCloseConfirm = useCallback(() => {
    setIsConfirmOpen(false)
  }, [])

  const handleSubmit = useCallback(() => {
    onUnreject()
    setIsConfirmOpen(false)
  }, [onUnreject])

  return (
    <div css={tw`w-full bg-white`}>
      <Button
        fullWidth
        className={tw`px-8`}
        size="small"
        color="grey"
        endIcon={<CircleTickMajor width={20} height={20} />}
        disabled={statusIsUpdating}
        onClick={handleOpenConfirm}
      >
        Unreject contractor
      </Button>
      <SensitiveActionModal
        isOpen={isConfirmOpen}
        title="Unreject contractor?"
        text="Are you sure you want to unreject contractor?"
        submitLabel="Unreject"
        color="green"
        onClose={handleCloseConfirm}
        onSubmit={handleSubmit}
      />
    </div>
  )
}

export const UnrejectContractor = memo(UnrejectContractorComponent)
